import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconCopySvg } from './IconCopySvg';

export const IconCopy: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconCopySvg} {...iconProps} />;
};
